import {
	resendVerificationEmail,
	ResendVerificationEmailPayload,
} from "@/api/resend-verification-email";
import { MutationOptionsWithoutFn } from "@/types/types";
import { queryOptions, useMutation, useQuery } from "@tanstack/react-query";

export const resendVerificationEmailKeys = {
	onReturn: (guestId: number) =>
		["resend-verification-email", "on-return", guestId] as const,
};

export function resendVerificationEmailOnReturnQueryOptions(guestId: number) {
	return queryOptions({
		queryKey: resendVerificationEmailKeys.onReturn(guestId),
		queryFn: () =>
			resendVerificationEmail({
				guest_id: guestId,
				email_verification_callback: `${window.location.origin}/verify-email`,
			}),
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: Number.POSITIVE_INFINITY,
		retry: false,
	});
}

export const useResendVerificationEmailOnReturn = (
	enabled: boolean,
	guestId: number,
) =>
	useQuery({
		...resendVerificationEmailOnReturnQueryOptions(guestId),
		enabled: enabled && !!guestId,
	});

export const useResendVerificationEmail = (
	options?: MutationOptionsWithoutFn<void, ResendVerificationEmailPayload>,
) => {
	return useMutation({
		mutationFn: resendVerificationEmail,
		...options,
	});
};
